"use client";
import { Box, Columns, Row, Text } from "@dxp-feed/ui";
import { SiteContainer } from "@/components/Container";
import StoreDetailMapView from "@/templates/storeDetail/StoreDetailMapView";
import { IListStores } from "@/utils/redux/storeLocator";
import Link from "@/components/Link";

interface IStoreDetailSelectionProps {
  store: IListStores | null;
  selectedStore: IListStores;
  openDialog: () => void;
  setStoreToConfirm: (store: IListStores) => void;
}

const StoreDetailSelection: React.FC<IStoreDetailSelectionProps> = ({
  store,
  selectedStore,
  openDialog,
  setStoreToConfirm,
}) => {
  return (
    <SiteContainer className="max-w-full  2md:px-0 px-0">
      <Row className="mx-auto bg-[#003D2A] max-w-[1920px] lgs:flex-row flex-col-reverse">
        <Columns className="lgs:!w-1/2 w-full py-14  7xl:!pl-[12.5%] 6xl:!pl-[13%] 2md:!p-12 !p-6">
          {store?.storeNumber == selectedStore?.storeNumber && (
            <Text
              as="span"
              className="rounded-[4px] bg-brandWhite py-[2px] px-2 text-body font-semibold mb-4 text-[#003D2A] inline-block"
            >
              Selected Store
            </Text>
          )}
          <Text
            as="h1"
            className="font-sans 2md:text-5xl text-2xl text-brandWhite font-extrabold"
          >
            {store?.locationName}
          </Text>
          <Box className="flex 3xs:flex-row flex-col gap-4 pt-4">
            <Link
              href={`/flyer?set_preferred_store_number=${store?.storeNumber}`}
              className="!w-auto"
            >
              <button
                aria-label={"View Flyer"}
                className="buttonDirection !border-brandWhite flex gap-3 justify-center items-center !border-[1px] 2xs:!text-[14px] 3xs:!text-sm  [&>.icon-flyer:before]:text-[17px] [&>.icon-flyer:before]:!w-6 [&>.icon-flyer:before]:flex [&>.icon-flyer:before]:items-center [&>.icon-flyer:before]:h-6 [&>.icon-flyer:before]:hover:text-brandSecondary [&>.icon-flyer:before]:focus:text-brandSecondary "
              >
                <Text
                  as="span"
                  className="icon-flyer w-6 h-6 flex text-brandWhite text-2xl"
                />
                View Flyer
              </button>
            </Link>
            {store?.storeNumber !== selectedStore?.storeNumber && (
              <button
                className="buttonSelectStore !border-brandWhite !border-[1px] !w-auto 2xs:!text-[14px]  3xs-!text-sm"
                type="submit"
                onClick={() => {
                  openDialog();
                  setStoreToConfirm(store as IListStores);
                }}
                aria-label="Select this store"
              >
                Select this store
              </button>
            )}
          </Box>
        </Columns>
        <Columns className="lgs:!w-1/2 w-full">
          {/* store detail map view */}
          <StoreDetailMapView store={store} />
        </Columns>
      </Row>
    </SiteContainer>
  );
};

export default StoreDetailSelection;
